module.exports = __webpack_public_path__ + "static/media/20ECE13.91fa0086.jpg";